// // src/ProfilePage.js
// import React from 'react';
// import { useSelector } from 'react-redux';
// import '../CSS/ProfilePage.css';

// const ProfilePage = () => {
//   const userInfo = useSelector((state) => state.userInfo);

//   return (
//     <div className="profile-page">
//       <h2>PROFILE</h2>
//       <p><strong style={{color:"rgba(0,0,255,0.7)"}}>Name:</strong> {userInfo?.fullName}</p>
//       <p><strong style={{color:"rgba(0,0,255,0.7)"}}>Email:</strong> {userInfo?.email}</p>
//       <p><strong style={{color:"rgba(0,0,255,0.7)"}}>Phone:</strong> {userInfo?.phoneNumber}</p>
//     </div>
//   );
// };

// export default ProfilePage;



// src/components/ProfilePage.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const ProfilePage = () => {
  const userInfo = useSelector((state) => state.userInfo);

  // Get first letter of name for the avatar
  const initials = userInfo?.fullName ? userInfo.fullName.charAt(0).toUpperCase() : 'U';

  return (
    <ProfileContainer>
      <PageHeader>
        <h2>Account Profile</h2>
        <p>View and manage your personal account information.</p>
      </PageHeader>

      <ProfileCard>
        <ProfileHeaderInfo>
          <Avatar>{initials}</Avatar>
          <div>
            <h3>{userInfo?.fullName || 'User'}</h3>
            <span>{userInfo.role==="admin"?"Admin":"Member"} Account</span>
          </div>
        </ProfileHeaderInfo>

        <InfoGrid>
          <InfoItem>
            <Label>Full Name</Label>
            <Value>{userInfo?.fullName || 'Not provided'}</Value>
          </InfoItem>

          <InfoItem>
            <Label>Email Address</Label>
            <Value>{userInfo?.email || 'Not provided'}</Value>
          </InfoItem>

          <InfoItem>
            <Label>Phone Number</Label>
            <Value>{userInfo?.phoneNumber || 'Not provided'}</Value>
          </InfoItem>
        </InfoGrid>
      </ProfileCard>
    </ProfileContainer>
  );
};

export default ProfilePage;

// --- Styled Components ---
const ProfileContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  font-family: inherit;
`;

const PageHeader = styled.div`
  margin-bottom: 24px;

  h2 {
    color: #0f172a;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 4px 0;
  }

  p {
    color: #64748b;
    font-size: 0.95rem;
    margin: 0;
  }
`;

const ProfileCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  padding: 32px;
`;

const ProfileHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 24px;

  h3 {
    margin: 0 0 4px 0;
    color: #0f172a;
    font-size: 1.25rem;
  }

  span {
    background: #e0f2fe;
    color: #0369a1;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
  }
`;

const Avatar = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
`;

const InfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px solid #f1f5f9;
`;

const Label = styled.span`
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  font-weight: 600;
`;

const Value = styled.span`
  font-size: 1.05rem;
  color: #1e293b;
  font-weight: 500;
`;